
































import {
  createComponent,
  inject,
  onMounted,
  computed,
  reactive
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import FormHeader from '../../molecules/FormHeader.vue'
import EvaluationDialog from './EvaluationDialog.vue'
export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const getEvaluationInfor = company.getEvaluationInfor
    onMounted(() => {
      getEvaluationInfor()
    });
    
    const companyInfor = computed(() => company.tableEvaluationList);
    const rowValue = reactive ({
      value: {} as any
    });
    const dialog = computed(() => displayui.dialogEvaluationList);
    const openDialog = (item: any) => {      
      rowValue.value = item
      displayui.openEvaluationListDialog()
    }
    const commentValue = ((comment:string) => {
      if(comment && comment.length > 20){
        return comment.substring(0, 19) + '...';
      }else{
        return comment;
      }
    })
    return {
      companyInfor,
      dialog,
      openDialog,
      rowValue,
      commentValue
    };
  },

  components: {
    FormHeader,
    EvaluationDialog
  },

})
